import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Alert } from 'reactstrap';
import AgencyPlansModal from './AgencyPlansModal';
import './AgencyPlansModal.css';
import { justifyContent, margin } from '../../../node_modules/@mui/system/index';

const PaymentRequiredBanner = () => {
  const { currentSubscription } = useSelector((state) => state['Settings']);
  const [showAgencyPlansModal, setShowAgencyPlansModal] = useState(false);

  const toggleModal = () => setShowAgencyPlansModal(!showAgencyPlansModal);

  // Don't show banner if not locked
  if (!currentSubscription || !currentSubscription.isLocked) return null;

  const lockReason = currentSubscription.lockReason;
  const gracePeriodEndsAt = currentSubscription.gracePeriodEndsAt;
  const isGracePeriodExpired = gracePeriodEndsAt && new Date(gracePeriodEndsAt) < new Date();

  // Determine message and alert color based on lockReason and grace period
  let bannerMessage = '';
  let alertColor = 'warning';

  const graceDeadline = !isGracePeriodExpired && gracePeriodEndsAt ? formatGraceDeadline(gracePeriodEndsAt) : null;

  if (lockReason === 'payment_required') {
    bannerMessage = 'Please activate your plan to continue using all features.';
    alertColor = 'warning';
  } else if (lockReason === 'payment_failed') {
    if (isGracePeriodExpired) {
      bannerMessage = 'Your subscription payment has expired and grace period has expired. Please update your billing information to continue.';
      alertColor = 'danger';
    } else if (graceDeadline) {
      bannerMessage = `Your subscription payment has expired. Please update your billing information before your grace period ends ${graceDeadline}, after which your workspace will be locked.`;
      alertColor = 'warning';
    } else {
      bannerMessage = 'Your subscription payment has expired. Please update your billing information before grace period ends.';
      alertColor = 'warning';
    }
  } else if (graceDeadline) {
    bannerMessage = `Please update your billing information before your grace period ends ${graceDeadline}, after which your workspace will be locked.`;
    alertColor = 'warning';
  } else {
    bannerMessage = 'Please update your billing information to continue using all features.';
    alertColor = 'warning';
  }

  return (
    <>
      <Alert color={alertColor} className='payment-banner' style={{margin: '0px'}} >
        <div className="banner-content" style={{display:'flex', justifyContent:'space-between', }}>
          <div className='notification-text'>
            <i className="fa fa-exclamation-triangle banner-icon mr-3" ></i>
            <span className="banner-text" sx={{display:'flex', justifyContent:'space-between'}}>
              <strong>{lockReason === 'payment_required' ? 'Payment Required:' : 'Subscription Issue:'}</strong> {bannerMessage}
            </span>
          </div>
          <button className="btn-style-new billing-button" onClick={toggleModal}>
            {lockReason === 'payment_required' ? 'Activate Plan' : 'Update Billing'}
          </button>
        </div>
      </Alert>

      <AgencyPlansModal
        isOpen={showAgencyPlansModal}
        toggle={toggleModal}
      />
    </>
  );
};

const formatGraceDeadline = (endsAt) => {
  const end = new Date(endsAt);
  const daysLeft = Math.ceil((end - new Date()) / (1000 * 60 * 60 * 24));
  const dateText = end.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  return `on ${dateText} (${daysLeft} ${daysLeft === 1 ? 'day' : 'days'} left)`;
};

export default PaymentRequiredBanner;
